import { toReadableNumber } from '@popety_io/popety-io-lib'

const plusSignNumber = (num: number) => {
  return (num < 0 ? '' : '+') + toReadableNumber(num)
}

export { plusSignNumber }
